// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const RegisterWithInviteLoader = Loadable({
  loader: () => import('./RegisterWithInviteContainer'),
  loading: Loader,
})

export default RegisterWithInviteLoader
